const navigation = () => {
    const navItems = document.querySelectorAll('.main-item.menu-item');
    const isEditMode = document.querySelector('#wpadminbar');
    const mq = window.matchMedia( "(min-width: 1140px)" );
    if(isEditMode) {
        $('body, header, .block-anchor-links-bar').addClass('edit-mode');
    }

    $(document).on('click', '#hamburger', function (e) {
        $('header').toggleClass('active');
    });

    $(document).on('click', '.footer-back-to-top', function (e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

    const removeActiveClasses = () => {
        navItems.forEach(element => element.classList.remove('active'));
    };

    navItems.forEach(item => {
        item.addEventListener('click', (e) => {
            if (item.classList.contains('active')) {
                item.classList.remove('active');
            } else {
                removeActiveClasses();
                item.classList.add('active');
            }
        });

        item.addEventListener('mouseenter', () => {
            if(mq.matches) {
                removeActiveClasses();
                item.classList.add('active');
            }
        });

        item.addEventListener('mouseleave', () => {
            if(mq.matches) item.classList.remove('active');
        });
    });

    document.addEventListener('click', (e) => {
        if (![...navItems].some(item => item.contains(e.target))) {
            removeActiveClasses();
        }
    });
};

export default navigation;